module.exports = __webpack_public_path__ + "img/P3.c5af43a6.png";